import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const expiresInState = atom({
  key: 'expiresIn',
  default: '',
  effects: [
    persistAtomEffect
  ]
});
